import { SessionStore } from '.';

/**
 * Return whether user is authenticated.
 */
export function useIsAuthenticated() {
  return SessionStore.useState(
    (state) => typeof state.session === 'object' && typeof state.session.authentication.dashboard === 'string',
  );
}

/**
 * Return session data or throw if missing.
 */
export function useSession() {
  const session = SessionStore.useState((state) => state.session);
  if (!session) {
    throw new Error('Missing session!');
  }
  return session;
}

/**
 * Return current user object.
 */
export function useCurrentUser() {
  const session = useSession();
  return session.user;
}

/**
 * Return user's name or fallback to e-mail address.
 *
 * Default to email if login was redirected from Admin Dashboard.
 */
export function useUserName(): string | undefined {
  const user = useCurrentUser();
  const session = useSession();

  if (session.companion.fromAdmin) {
    return user.email;
  }

  return user.name && user.name.length > 0 ? user.name : user.email;
}
